import { HOME } from '@/constants/testIds';

const ITEMS = [
    'Voice control for FL Studio',
    'Offline recognition',
    'Wake phrases — Engineer / Engine',
    'Optional wake chime',
    'Mic-level display & voice test',
    'One-time purchase — no subscription',
    'Keep your focus on the music',
];

const Copy = () => (
    <div className="flex items-center gap-10 pr-10">
        {ITEMS.map((item) => (
            <span
                key={item}
                className="flex items-center gap-10 whitespace-nowrap font-mono text-xs uppercase tracking-[0.25em] text-zinc-500"
            >
                {item}
                <span className="h-1 w-1 rotate-45 bg-aqua/50" aria-hidden="true" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div data-testid={HOME.marquee} className="relative overflow-hidden border-y border-white/10 py-5">
        <div className="marquee-track flex w-max">
            <Copy />
            <div aria-hidden="true">
                <Copy />
            </div>
        </div>
    </div>
);
